<main class="w-full bg-white shadow-sm">
  <!-- Dynamic Grid Component -->
  <app-dynamic-grid
    [gridConfig]="gridConfig"
    [getDataUrl]="getDataUrl"
    [sortBy]="'backupDate'"
    [sortOrder]="'desc'"
    (onToggleShowToastEmitter)="showToast($event)">
  </app-dynamic-grid>
  
  <app-toast></app-toast>
</main>